// this file added by Bearer Web Developer

import React from "react";
import { getSystemTheme, initialThemeMode, ThemeContext, ThemeMode } from "../../../states/contexts/theme";

const ThemeModeProvider: React.FC<{ children: React.ReactNode; }> = ({ children }) => {

    const [theme, setTheme] = React.useState<ThemeMode>(initialThemeMode);
    // const [systemTheme, setSystemTheme] = React.useState<boolean>(!localStorage?.getItem('theme'));
    const [systemTheme, setSystemTheme] = React.useState<boolean>(true); // in load time, we will always set theme to system theme
    const setThemeMode = (theme_mode: ThemeMode | 'system', force?: boolean) => {
        try {
            let oldTheme = theme;
            setSystemTheme(theme_mode === 'system');
            const newTheme = theme_mode === 'system' ? getSystemTheme() : theme_mode;
            if (theme_mode === 'system') localStorage?.removeItem('theme');
            else localStorage.setItem('theme', newTheme);
            if (newTheme !== theme || force) setTheme(newTheme);
            if (document?.documentElement) {
                document.documentElement.classList.add(newTheme);
                document.documentElement.classList.remove(oldTheme);
                let meta = document.querySelector('meta[name="theme-color"]');
                if (!meta) {
                    meta = document.createElement("meta");
                    meta.setAttribute("name", "theme-color");
                    document.head.appendChild(meta);
                }
                const color = getSystemTheme() === ThemeMode.Dark ? "#262626" : "#14438E";
                meta.setAttribute("content", color);
            }
        } catch (e) {
            console.error("Theme detection error:", e);
        }
    };
    const toggleTheme = () => {
        try {
            let newTheme = ThemeMode.Light;
            let oldTheme = ThemeMode.Light;
            if (systemTheme) {
                // System Theme -> Light Theme
                oldTheme = getSystemTheme();
                newTheme = ThemeMode.Light;
                setTheme(ThemeMode.Light);
                localStorage.setItem('theme', ThemeMode.Light);
                setSystemTheme(false);
            } else if (theme === ThemeMode.Light) {
                // Light Theme -> Dark Theme
                oldTheme = ThemeMode.Light;
                newTheme = ThemeMode.Dark;
                if (systemTheme) setSystemTheme(false);
                setTheme(ThemeMode.Dark);
                localStorage.setItem('theme', ThemeMode.Dark);
            } else {
                // Dark Theme -> System Theme
                oldTheme = ThemeMode.Dark;
                newTheme = getSystemTheme();
                if (!systemTheme) setSystemTheme(true);
                setTheme(getSystemTheme());
                localStorage?.removeItem('theme');
            }
            if (document?.documentElement) {
                document.documentElement.classList.add(newTheme);
                document.documentElement.classList.remove(oldTheme);
            }
        } catch (e) {
            console.error("Theme detection error:", e);
        }
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme, systemTheme, setThemeMode }}>
            {children}
        </ThemeContext.Provider>
    )
}
export default ThemeModeProvider;